import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .BaseStaticInput {
    position: relative;
    width: 100%;
    height: 44px;
    display: flex;
    flex-direction: column;

    &__OpenOptionsButton {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 16px;
      padding-right: 16px;
      border: 1px solid #f3f3f3;
      border-radius: 8px;
      height: 100%;
      position: relative;
      font-size: 14px;
      line-height: 1.4;
      color: #333;
      background-color: #fff;

      &:disabled {
        background: #f9f9f9;
      }
    }

    &__OptionMulti--Selected {
      background: rgba(10, 161, 226, 0.4);
    }

    &__Option {
      padding-left: 12px;
      display: flex;
      align-items: center;
      height: 30px;
      position: relative;
      &:hover {
        background: #ceecf9;
      }
    }

    &__Option--FastFilter {
      height: 34px;
      min-height: 34px !important;
    }

    &__Input {
      border: 0;
      background: transparent;
      width: 100%;
      height: 100%;
      padding-top: 9px;
      padding-left: 0;
      color: #333;

      &:placeholder {
        color: #cecece;
      }

      &--disabled {
        color: #cecece;
      }
    }

    &__NewOption {
      display: flex;
      padding: 2px 8px;
      align-items: center;
      border-radius: 20px;
      background: #91a782;
      font-size: 12px;
      font-style: normal;
      font-weight: 300;
      line-height: 18px; /* 150% */
      background: gray;
      color: white;

      &:hover {
        background: #ceecf9;
        color: black;
      }
    }

    &__Labels {
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: auto auto;
    }

    &__LabelsSelected {
      display: flex;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
    }

    &__LabelsSelectedCentered {
      flex: 1; /* Expand to fill remaining space */
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &__LabelsAmount {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 4px 0 4px;
    }

    &__NewOption--isSelected {
      background: #0aa1e2;
    }
  }
`;

export { staticStyles };
